import { notificationLink } from './notificationLinks';

export function isNotificationUnread(notification) {
  return notification?.is_read !== true;
}

/**
 * Open a notification: mark read when needed, then navigate if a safe link exists.
 * Returns true when navigation occurred.
 */
export function handleNotificationOpen({
  notification,
  user,
  navigate,
  markAsRead,
  closeDropdown,
}) {
  if (!notification) return false;

  const link = notificationLink(notification, user);
  const unread = isNotificationUnread(notification);

  if (link) {
    if (unread && typeof markAsRead === 'function') {
      markAsRead(notification.id);
    }
    if (typeof closeDropdown === 'function') {
      closeDropdown();
    }
    if (typeof navigate === 'function') {
      navigate(link);
    }
    return true;
  }

  if (unread && typeof markAsRead === 'function') {
    markAsRead(notification.id);
  }
  return false;
}
